<template>
  <w-sliding-popup ref="slidingPopup" :title="`${titleLengthOverCut(selectNode.label)} 관련 로그 목록`" width="800px" @close="close">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4">로그 발생 횟수</div>
        <el-row>
          <el-button @click="onClickRefreshChart"><i class="fas fa-sync-alt"></i></el-button>
          <el-dropdown size="mini" type="primary" align="right" trigger="click" @command="compareChart">
            <el-button>
              <i class="fad fa-exchange-alt"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">어제</el-dropdown-item>
              <el-dropdown-item command="7">일주일 전</el-dropdown-item>
              <el-dropdown-item command="14">14일 전</el-dropdown-item>
              <el-dropdown-item command="30">한달 전</el-dropdown-item>
              <el-dropdown-item command="0" :divided="true" v-show="checkCompareFlag">닫기</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-row>
      </el-row>
      <el-row class="mr-b15" v-show="!checkCompareFlag">
        <w-log-message-chart ref="logMessageChart" @load-data="loadData" @select-column="setLogList" @setMaxValue="setMaxValue" :active="active" :compareFlag="false"></w-log-message-chart>
      </el-row>
      <el-row class="mr-b15" v-show="checkCompareFlag">
        <el-col :span="12">
          <w-log-message-chart ref="logMessageChart1" :maxYAxis="maxYAxis" @load-data="loadData" @select-column="setLogList" :active="checkCompareFlag" :compareFlag="false"></w-log-message-chart>
        </el-col>
        <el-col :span="12">
          <w-log-message-chart ref="logMessageChart2" :maxYAxis="maxYAxis" @load-data="loadData" @select-column="setLogList" @setMaxValue="setMaxBeforeValue" :active="checkCompareFlag" :compareFlag="true"></w-log-message-chart>
        </el-col>
      </el-row>
      <el-row class="vertical-center-box mr-b15">
        <el-col :span="9">
          <div class="title-h4">발생 로그</div>
        </el-col>
        <el-col :span="5">
          <el-select v-model="selectField" placeholder="검색유형" class="mr-r4">
            <el-option
              v-for="item in searchColumns"
              :key="item.prop"
              :label="item.label"
              :value="item.prop">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <w-search-field ref="groupSearch" @search="searchLog"/>
        </el-col>
      </el-row>
      <el-row>
        <el-table-wrapper
          :column-default="columnDefault"
          ref="logMessageTable"
          :data="logData"
          :columns="nodeColumn"
          :pagination="true"
          :show-custom-header="false"
          :show-search-tool="false"
          :total="total"
          @condition-change="onCurrentPageChange"
          highlight-current-row>
          <template slot-scope="scope" slot="message-slot">
            <w-log-keyword-message :fieldOptions="fieldOptions" :logMessage="scope.row"></w-log-keyword-message>
          </template>
        </el-table-wrapper>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isNil, cloneDeep } from 'lodash';

import { columnDefault } from '@/constants/table';
import LmsLogAPI from '@/api/log/integrated-log';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString, getIntervalDatetimeParams } from '@/utils/date';
import WSearchField from '@/components/form/SearchField';

import WLogKeywordMessage from '../components/LogKeywordMessage';
import WLogMessageChart from '../components/LogMessageChart';

export default {
  name: 'WLogKeyWordPopup',
  props: {
    selectNode: {
      type: Object,
    },
    timeOption: {
      type: Object,
    },
    search: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(['selectedNode']),
    maxYAxis() {
      return (this.maxValue > this.beforeMaxValue) ? this.maxValue : this.beforeMaxValue;
    },
  },
  components: {
    WLogKeywordMessage,
    WLogMessageChart,
    WSearchField,
  },
  data() {
    return {
      searchItem: '',
      selectField: 'originMessage',
      checkCompareFlag: false,
      maxValue: 0,
      start: 0,
      limit: 50,
      total: 0,
      beforeMaxValue: 0,
      active: false,
      paramData: null,
      selectedChartData: null,
      columnDefault,
      compareParams: null,
      currentParamData: null,
      logData: [],
      fieldOptions: [],
      command: 0,
      nodeColumn: [
        {
          prop: 'originMessage',
          label: '로그 메시지',
          scopedSlot: 'message-slot',
        },
        {
          prop: 'sourceName',
          label: '로그 소스',
          width: '130',
        },
        {
          prop: 'timestamp',
          label: '수집 시간',
          width: '130',
          formatter: this.getDateFormatter,
        },
      ],
      searchColumns: [
        {
          prop: 'originMessage',
          label: '로그 메시지',
        },
        {
          prop: 'sourceName',
          label: '로그 소스',
        },
      ],
    };
  },
  methods: {
    /**
 * 글자 수가 일정 이상 넘어간 경우 ... 으로 변경한다.
 * @author leesy918
 * @param  {[type]} txt     [description]
 * @param  {[type]} len     [description]
 * @param  {[type]} lastTxt [description]
 * @return {[type]}         [description]
 */
    titleLengthOverCut(txt, len, lastTxt) {
      let str = txt;
      let length = len;
      let changeStr = lastTxt;
      if (isNil(length)) {
        length = 40;
      }
      if (isNil(changeStr)) {
        changeStr = '...';
      }
      if (isNil(str)) {
        str = '';
      }
      if (str.length > length) {
        str = str.substr(0, length) + changeStr;
      }
      return str;
    },
    searchLog(value) {
      if (!isEmpty(value)) {
        this.searchItem = value;
        this.$refs.logMessageTable.setCurrentPage(1);
      }
    },
    setMaxBeforeValue(data) {
      this.beforeMaxValue = data;
    },
    setMaxValue(data) {
      this.maxValue = data;
    },
    /**
     * 차트 비교 이벤트
     * @author leesy918
     * @param  {[type]} command [description]
     * @return {[type]}         [description]
     */
    compareChart(command) {
      this.command = command;
      if (command === '0') {
        this.checkCompareFlag = false;
        this.compareParams = null;
      } else {
        this.checkCompareFlag = true;
        this.selectedChartData = null;
        const params = this.setParams();
        this.$refs.logMessageChart1.initChart(params);
        const compareParams = this.setParameter();
        compareParams.limit = 2000;
        const date = new Date(this.timeOption.selectStep);
        date.setDate(date.getDate() - command);
        compareParams.endDateTime = date.getTime();
        compareParams.startDateTime = new Date(date.getTime() - this.timeOption.interval).getTime();
        compareParams.queryList = [
          {
            field: this.selectNode.key,
            value: this.selectNode.label,
            operator: 'AND',
            regex: 'N',
          },
        ];
        this.compareParams = compareParams;
        this.$refs.logMessageChart2.initChart(compareParams);
      }
    },
    /**
     * 로그 상세보기 필드 조회 이벤트
     * @author leesy918
     * @return {[type]} [description]
     */
    loadColumnData() {
      LmsLogAPI.getLogShowFields().then((response) => {
        if (response.data.success) {
          const fieldList = response.data.data;
          if (!isNil(fieldList)) {
            fieldList.forEach((item, index) => {
              if (item.fieldId === 'originMessage') {
                fieldList.splice(index, 1);
              }
            });
          }
          this.fieldOptions = fieldList;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드', false));
        throw new Error(e);
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    setLogList(params) {
      if (isEmpty(params)) {
        this.selectedChartData = null;
      } else {
        this.selectedChartData = {
          ...params,
          limit: 50,
          start: 0,
        };
      }
      this.start = 0;
      this.limit = 50;

      this.$refs.logMessageTable.setCurrentPage(1);
    },
    /**
     * 저장소 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getIndexParams() {
      const params = { type: this.selectedNode.type, dataindexId: this.selectedNode.dataindexId };
      return params;
    },
    /**
     * 필터 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getFilterParams() {
      const params = { type: this.selectedNode.type, customFilterId: this.selectedNode.customFilterId };
      return params;
    },
    /**
     * 트리메뉴 선택에 따른 파라미터 작성 함수
     * @author leesy918
     */
    setParameter() {
      let params;
      if (this.selectedNode.type === 'dataindex') {
        params = this.getIndexParams();
      } else if (this.selectedNode.type === 'filter') {
        params = this.getFilterParams();
      } else if (this.selectedNode.type === 'group') {
        params = {
          type: 'group',
          filterGroupId: this.selectedNode.filterGroupId,
        };
      } else {
        params = {
          type: 'root',
        };
      }
      params = {
        ...params,
        start: 0,
      };

      return params;
    },
    setParams() {
      const params = this.setParameter();
      const date = new Date(this.timeOption.selectStep);
      params.endDateTime = this.timeOption.selectStep;
      params.startDateTime = new Date(date.getTime() - this.timeOption.interval).getTime();
      if (isEmpty(this.selectedChartData)) {
        params.queryList = [
          {
            field: this.selectNode.key,
            value: this.selectNode.label,
            operator: 'AND',
            regex: 'N',
          },
        ];
        this.paramData = params;
        this.paramData.limit = this.limit;
        this.paramData.start = this.start;
        this.currentParamData = params;
      } else {
        if (this.selectedChartData.compareFlag) {
          params.endDateTime = this.compareParams.endDateTime;
          params.startDateTime = this.compareParams.startDateTime;
        }
        if ((params.endDateTime > this.selectedChartData.endDateTime)) {
          params.endDateTime = this.selectedChartData.endDateTime;
        }
        if ((params.startDateTime < this.selectedChartData.startDateTime)) {
          params.startDateTime = this.selectedChartData.startDateTime;
        }
        params.queryList = this.selectedChartData.queryList;
        params.limit = this.limit;
        params.start = this.start;

        this.paramData = params;
        this.currentParamData = params;
      }

      return params;
    },
    /**
     * 로그 리스트 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData(params) {
      let tableParams = cloneDeep(params);
      if (isEmpty(params)) {
        tableParams = this.setParams();
      }
      // 차트는 start 이상 end 미만으로 조회해옴 > 테이블 데이터는 start 이상 end 이하로 조회하기 때문에 개수 차이 발생
      // 해당 이슈 처리하기 위해 end 시간 조절 (-1ms)
      tableParams.endDateTime -= 1;
      this.active = true;
      if (!isEmpty(this.searchItem)) {
        tableParams.queryList.push(
          {
            field: this.selectField,
            value: this.searchItem,
            operator: 'AND',
            regex: 'N',
          });
      }
      if (!isNil(tableParams)) {
        LmsLogAPI.getLogDatas(tableParams).then((response) => {
          if (response.data.success) {
            this.logData = response.data.data;
            this.total = response.data.total;
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
          throw new Error(e);
        });
      }
    },
    onCurrentPageChange(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.loadData();
    },
    onClickRefreshChart() {
      this.selectedChartData = null;
      const params = this.setParams();
      if (this.checkCompareFlag) {
        this.compareChart(this.command);
      } else {
        this.$refs.logMessageChart.initChart(params);
      }
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.loadColumnData();
        const params = this.setParams();
        this.$refs.logMessageChart.initChart(params);
      });
    },
    close() {
      this.$refs.groupSearch.clear();
      this.$refs.logMessageTable.setCurrentPage(1);
      this.$refs.logMessageChart.closePopup();
      this.$refs.logMessageChart1.closePopup();
      this.$refs.logMessageChart2.closePopup();

      this.start = 0;
      this.limit = 50;
      this.maxValue = 0;
      this.beforeMaxValue = 0;
      this.active = false;
      this.checkCompareFlag = false;
      this.paramData = null;
      this.searchItem = '';
      this.selectField = 'originMessage';
      this.selectedChartData = null;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/popup/LogKeywordPopup.vue